const Percent2Template = (rowData, { field }) => {
  return `${rowData[field].toFixed(2)}%`;
};
export default Percent2Template;
